export default "__VITE_ASSET__0a7691c0__"